import React from "react";
import { FormGroup, Label, Input, FormFeedback } from "reactstrap";
import { useField } from "formik";

//App
import { TextFieldProps } from "../../../../types";

const TextField: React.FC<TextFieldProps> = ({
  label,
  name,
  style,
  type = "text",
  isRequired,
  onChange,
  onKeyDown,
  disabled,
  ignoreFieldChangeOnEmpty = false,
  decimalPlace = 0,
}) => {
  const [field, meta] = useField(name);
  const { onChange: fieldOnChange, value, ...fieldProps } = field;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Formik's onChange handler
    if (!ignoreFieldChangeOnEmpty) fieldOnChange(e);
    else {
      e.target.value.toString().length && fieldOnChange(e);
    }

    // Custom onChange, if provided
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <FormGroup floating style={style}>
      <Input
        type={type}
        value={
          decimalPlace
            ? String(value.toFixed(decimalPlace))
            : value ?? undefined
        }
        {...fieldProps}
        id={name}
        name={name}
        placeholder={label}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        invalid={meta?.touched && !!meta?.error}
        disabled={disabled}
      />
      <Label for={name}>{isRequired ? `${label} *` : label}</Label>
      {meta?.touched && meta?.error && (
        <FormFeedback>{meta?.error}</FormFeedback>
      )}
    </FormGroup>
  );
};

export default TextField;
